import { v, type Infer } from "convex/values";

/**
 * Kind of a document block. `verse-line` is emitted ONLY for corpus ORIGINALS
 * (a continuous-verse poem split one block per metrical line — see
 * scripts/ingest/verseLines.ts); `retellMaster` and retelling blocks are only
 * ever `paragraph`/`heading`. Extend if the corpus needs more (e.g. blockquote).
 */
export const blockKindValidator = v.union(
  v.literal("paragraph"),
  v.literal("heading"),
  v.literal("verse-line"),
);
export type BlockKind = Infer<typeof blockKindValidator>;

/**
 * One retelling block. `id` is a stable block id minted once at seed time and
 * never regenerated — anchors, bookmarks, and pending edits all key on it, so
 * published edits only invalidate references inside the edited block
 * (SPEC "Document model").
 */
export const blockValidator = v.object({
  id: v.string(),
  kind: blockKindValidator,
  text: v.string(),
});
export type Block = Infer<typeof blockValidator>;
